export const optinColors = Object.freeze({
  optin: "lime",
  optout: "rose",
  neverOptin: "zinc",
});
